'use client';

import { ChevronLeft } from "lucide-react";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import { Button } from "./ui/button";

interface SubHeaderProps {
      title?: string;
      subtitle?: string;
      canGoBack?: boolean;
      showBackButtonTitle?: boolean;
}

const SubHeader = ({ title, subtitle, canGoBack, showBackButtonTitle }: SubHeaderProps) => {
      const router = useRouter();
      const t = useTranslations('_common');

      const onBack = () => {
            router.back();
      }

      return <div className="flex-1 flex items-center gap-2">
            {canGoBack && (
                  <Button variant="link" className="gap-1 p-0" onClick={onBack}>
                        <ChevronLeft className="size-4" />
                        {showBackButtonTitle && <span className="text-sm">{t('back')}</span>}
                  </Button>
            )}
            <div className="flex flex-col gap-2">
                  <h4 className="text-2xl font-bold truncate">{title}</h4>
                  {subtitle && <p className="text-sm text-muted-foreground truncate">{subtitle}</p>}
            </div>

      </div>;
};

export default SubHeader;
